import { CheckIcon } from '..';
import { FIRM_AVALABILITY_CONSTANT } from '../../../utils/constant';
import { DesContent } from '../DescriptionModal/Description.styled';
import { Div, TextLabel } from './firmAvailabilityModal.styled';
import { FirmAvProps } from './firmAvailbilityModal.props';

const FirmAvailabilityModal = ({ firmAvailData }: FirmAvProps) => {

    return (
        <Div className="container">
            {
                firmAvailData &&
                <DesContent className="description">
                    {firmAvailData.commerceFirmData!.acceptingClients ?
                        <Div className="availble-item" >
                            <Div className='icon'>
                                <CheckIcon />
                            </Div>
                            <TextLabel>{FIRM_AVALABILITY_CONSTANT.ACCEPTING_CLIENT}</TextLabel>
                        </Div> : ""}
                    {firmAvailData.commerceFirmData!.willingOfferAdvice ?
                        <Div className="availble-item" >
                            <Div className='icon'>
                                <CheckIcon />
                            </Div>
                            <TextLabel>{FIRM_AVALABILITY_CONSTANT.OFFER}</TextLabel>
                        </Div> : ""}
                    {firmAvailData.commerceFirmData!.loanStaff ?
                        <Div className="availble-item" >
                            <Div className='icon'>
                                <CheckIcon />
                            </Div>
                            <Div className="lable">
                                <TextLabel>{FIRM_AVALABILITY_CONSTANT.SHARE_TALENT}</TextLabel>
                            </Div>
                        </Div> : ""}
                    {firmAvailData.commerceFirmData!.receiveStaff ?
                        <Div className="availble-item" >
                            <Div className='icon'>
                                <CheckIcon />
                            </Div>
                            <Div className="lable">
                                <TextLabel>{FIRM_AVALABILITY_CONSTANT.HOST_SHARE_TALENT}</TextLabel>
                            </Div>
                        </Div> : ""}
                    {firmAvailData.commerceFirmData!.globalOpportunities ?
                        <Div className="availble-item" >
                            <Div className='icon'>
                                <CheckIcon />
                            </Div>
                            <Div className="lable">
                                <TextLabel>{FIRM_AVALABILITY_CONSTANT.OFFER_OPPORTUNITIES}</TextLabel>
                            </Div>
                        </Div> : ""}
                </DesContent>
            }
        </Div>
    )
}

export default FirmAvailabilityModal;